import script from "./dialogue.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogue.vue?vue&type=script&setup=true&lang=js"

import "./dialogue.vue?vue&type=style&index=0&id=4dc85a11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc85a11"]])

export default __exports__